 @if(loadingService.isLoading$ | async) {
<div class="loading-overlay">
    <img src="assets/images/logo-o.png" alt="Loading" class="loading-logo">
</div>
}
<app-header></app-header>

<main [class.home-main]="isHomePage">
    <router-outlet></router-outlet>
</main>

<app-footer></app-footer>

@if(notification && notification.type != null){
<app-notification [type]="notification.type" [message]="notification.message"></app-notification>
}
<app-scroll-to-top></app-scroll-to-top>